export default __webpack_public_path__ + "32817522c6e62f7bb382dcddefa0e00a.png";